import React from 'react';
import './index.scss';

export default function FeedsEditbox(props: any) {
  return (
    <div
      className="feeds-editbox"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div className="feeds-editbox-hd">{props.hd}</div>
      <div className="feeds-editbox-bd">{props.bd}</div>
      <div className="feeds-editbox-ft">{props.ft}</div>
    </div>
  );
}
